import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";

// Routes
import routes from "./routes";
import { registerDynamicRoutes } from "../utils/routerUtils";

import store from "../store";

Vue.use(Router);

// Create a new router
const router = new Router({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

Vue.use(Meta);


let dynamicConfigured = false;
router.beforeEach((to, from, next) => {
  const publicPages = ["/login-test"];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = store.getters["auth/isAuthenticated"];

  if (authRequired && !loggedIn) {
    return next("/login-test");
  }

  // Solo configurar rutas dinámicas una vez por sesión
  if (!dynamicConfigured) {
    const options = localStorage.getItem("options");
    if (options) {
      try {
        const parsedOptions = JSON.parse(options);
        registerDynamicRoutes(router, parsedOptions);
        dynamicConfigured = true;
        // Forzar navegación a la ruta deseada tras agregar rutas
        return next(to.path);
      } catch (e) {
        dynamicConfigured = true;
      }
    } else {
      dynamicConfigured = true;
    }
  }

  next();
});


export default router;
